module.exports = __webpack_public_path__ + "image/1-3-21.jpg";